// extracted by mini-css-extract-plugin
module.exports = {"vote":"vote-ciHozqAA","voted":"voted-Ly5H44ZZ"};